
import {
  UPDATE_STAT_LOADING_STATUS,

  GET_ALL_PRODUCR_LIST,
  GET_ALL_APP_LIST,

  GET_REGISTER_USER,
  GET_REGISTER_USER_CHAIN,
  GET_REGISTER_USER_SUM,

  GET_LIVELY_USER,
  GET_LIVELY_USER_CHAIN,
  GET_LIVELY_USER_SUM,

  GET_ACTIVE_DEVICE,
  GET_ACTIVE_DEVICE_CHAIN,
  GET_ACTIVE_DEVICE_SUM,

  GET_LIVELY_DEVICE,
  GET_LIVELY_DEVICE_CHAIN,
  GET_LIVELY_DEVICE_SUM,

} from "../actions/stat";
// import { pageSize } from "../../../common/utils/index";

const defVal = {
  loading: false,

  registerUsers: [],
  registerUsersChain: [],
  registerUsersSum: [{
    count: 0,
    monthCount: 0,
    weekCount: 0,
    yesterdayCount: 0
  }],
  
  livelyUsers: [],
  livelyUsersChain: [],
  livelyUsersSum: [{
    count: 0,
    monthCount: 0,
    weekCount: 0,
    yesterdayCount: 0
  }],

  activeDevices: [],
  activeDeviceChain: [],
  activeDevicesSum: [{
    count: 0,
    monthCount: 0,
    weekCount: 0,
    yesterdayCount: 0
  }],

  livelyDevices: [],
  livelyDeviceChain: [],
  livelyDevicesSum: [{
    count: 0,
    monthCount: 0,
    weekCount: 0,
    yesterdayCount: 0
  }],

  appList: [],
  productList: []
};

export default (state = defVal, action) => {
  switch (action.type) {
    case UPDATE_STAT_LOADING_STATUS:
      return Object.assign({}, state, {
        loading: action.loading,
      });

    case GET_ALL_PRODUCR_LIST:
      return Object.assign({}, state, {
        productList: action.productList,
      });
    case GET_ALL_APP_LIST:
      return Object.assign({}, state, {
        appList: action.appList,
      });

    case GET_REGISTER_USER:
      return Object.assign({}, state, {
        registerUsers: action.registerUsers,
      });
    case GET_REGISTER_USER_CHAIN:
      return Object.assign({}, state, {
        registerUsersChain: action.registerUsersChain,
      });
    case GET_REGISTER_USER_SUM:
      return Object.assign({}, state, {
        registerUsersSum: action.registerUsersSum,
      });

    case GET_LIVELY_USER:
      return Object.assign({}, state, {
        livelyUsers: action.livelyUsers,
      });
    case GET_LIVELY_USER_CHAIN:
      return Object.assign({}, state, {
        livelyUsersChain: action.livelyUsersChain,
      });
    case GET_LIVELY_USER_SUM:
      return Object.assign({}, state, {
        livelyUsersSum: action.livelyUsersSum,
      });

    case GET_ACTIVE_DEVICE:
      return Object.assign({}, state, {
        activeDevices: action.activeDevices,
      });
    case GET_ACTIVE_DEVICE_CHAIN:
      return Object.assign({}, state, {
        activeDeviceChain: action.activeDeviceChain,
      });
    case GET_ACTIVE_DEVICE_SUM:
      return Object.assign({}, state, {
        activeDevicesSum: action.activeDevicesSum,
      });

    case GET_LIVELY_DEVICE:
      return Object.assign({}, state, {
        livelyDevices: action.livelyDevices,
      });
    case GET_LIVELY_DEVICE_CHAIN:
      return Object.assign({}, state, {
        livelyDeviceChain: action.livelyDeviceChain,
      });
    case GET_LIVELY_DEVICE_SUM:
      return Object.assign({}, state, {
        livelyDevicesSum: action.livelyDevicesSum,
      });

    default:
      return state;
  }
};
